// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-default {
  background-color: #fff;
  margin-top: 19px;
  padding: 30px;
  border-bottom: 5px solid #008cfe;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),
    0px 0px 4px 0px rgba(0, 0, 0, 0.04);
}
.card-1 {
  background-color: #fff;
  margin-top: 20px;
  padding: 30px 30px 20px 30px;
  border-bottom: 5px solid #008cfe;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),
    0px 0px 4px 0px rgba(0, 0, 0, 0.04);
  background-image: linear-gradient(to bottom, transparent 50%, #008cfe 50%);
  background-position: 0 0;
  background-size: 100% 200%;
  transition: background-position 0.25s ease-in;
}
.card-1:hover {
  background-position: 0 100%;
}

.card-1 button {
  background-color: transparent;
  border: 1px solid #828282;
  border-radius: 50px;
  color: #008cfe;
  width: 48%;
  padding: 5px 0px;
}

.notification-icon .badge {
  background-color: #eb5757;
  border-radius: 46.308px;
  font-size: 10px;
  padding: 3px 5px;
  vertical-align: top;
  margin-left: -16px;
}

.card-1:hover button {
  border: 1px solid #ffffff;
  border-radius: 50px;
  color: #ffffff;
  padding: 5px 0px;
}

.card-1:hover .notification-icon .badge {
  background-color: #ffffff !important;
  color: #008cfe;
}

.card-1:hover h6,
.card-1:hover h2,
.card-1:hover p {
  color: #ffffff !important;
}

.card-1:hover svg path {
  fill: #ffffff !important;
}

.card-2 {
  background-color: #fff;
  margin-top: 20px;
  padding: 30px 30px 20px 30px;
  border-bottom: 5px solid #03256c;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),
    0px 0px 4px 0px rgba(0, 0, 0, 0.04);
  background-image: linear-gradient(to bottom, transparent 50%, #03256c 50%);
  background-position: 0 0;
  background-size: 100% 200%;
  transition: background-position 0.25s ease-in;
}
.card-2:hover {
  background-position: 0 100%;
}

.card-2 button {
  background-color: transparent;
  border: 1px solid #828282;
  border-radius: 50px;
  color: #03256c;
  width: 48%;
  padding: 5px 0px;
}

.card-2:hover button {
  border: 1px solid #ffffff;
  border-radius: 50px;
  color: #ffffff;
  padding: 5px 0px;
}

.card-2:hover .notification-icon .badge {
  background-color: #ffffff !important;
  color: #03256c;
}

.card-2:hover h6,
.card-2:hover h2,
.card-2:hover p {
  color: #ffffff !important;
}

.card-2:hover svg path {
  fill: #ffffff !important;
}

.card-3 {
  background-color: #fff;
  margin-top: 20px;
  padding: 30px 30px 20px 30px;
  border-bottom: 5px solid #854c27;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),
    0px 0px 4px 0px rgba(0, 0, 0, 0.04);
  background-image: linear-gradient(to bottom, transparent 50%, #854c27 50%);
  background-position: 0 0;
  background-size: 100% 200%;
  transition: background-position 0.25s ease-in;
}
.card-3:hover {
  background-position: 0 100%;
}

.card-3 button {
  background-color: transparent;
  border: 1px solid #828282;
  border-radius: 50px;
  color: #854c27;
  width: 48%;
  padding: 5px 0px;
}

.card-3:hover button {
  border: 1px solid #ffffff;
  border-radius: 50px;
  color: #ffffff;
  padding: 5px 0px;
}

.card-3:hover .notification-icon .badge {
  background-color: #ffffff !important;
  color: #854c27;
}

.card-3:hover h6,
.card-3:hover h2,
.card-3:hover p {
  color: #ffffff !important;
}

.card-3:hover svg path {
  fill: #ffffff !important;
}

.card-4 {
  background-color: #fff;
  margin-top: 20px;
  padding: 30px 30px 20px 30px;
  border-bottom: 5px solid #dd7230;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),
    0px 0px 4px 0px rgba(0, 0, 0, 0.04);
  background-image: linear-gradient(to bottom, transparent 50%, #dd7230 50%);
  background-position: 0 0;
  background-size: 100% 200%;
  transition: background-position 0.25s ease-in;
}
.card-4:hover {
  background-position: 0 100%;
}

.card-4 button {
  background-color: transparent;
  border: 1px solid #828282;
  border-radius: 50px;
  color: #dd7230;
  width: 48%;
  padding: 5px 0px;
}

.card-4:hover button {
  border: 1px solid #ffffff;
  border-radius: 50px;
  color: #ffffff;
  padding: 5px 0px;
}

.card-4:hover .notification-icon .badge {
  background-color: #ffffff !important;
  color: #dd7230;
}

.card-4:hover h6,
.card-4:hover h2,
.card-4:hover p {
  color: #ffffff !important;
}

.card-4:hover svg path {
  fill: #ffffff !important;
}

.card-5 {
  background-color: #fff;
  margin-top: 20px;
  padding: 30px 30px 20px 30px;
  border-bottom: 5px solid #44af69;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),
    0px 0px 4px 0px rgba(0, 0, 0, 0.04);
  background-image: linear-gradient(to bottom, transparent 50%, #44af69 50%);
  background-position: 0 0;
  background-size: 100% 200%;
  transition: background-position 0.25s ease-in;
}
.card-5:hover {
  background-position: 0 100%;
}

.card-5 button {
  background-color: transparent;
  border: 1px solid #828282;
  border-radius: 50px;
  color: #44af69;
  width: 48%;
  padding: 5px 0px;
}

.card-5:hover button {
  border: 1px solid #ffffff;
  border-radius: 50px;
  color: #ffffff;
  padding: 5px 0px;
}

.card-5:hover .notification-icon .badge {
  background-color: #ffffff !important;
  color: #44af69;
}

.card-5:hover h6,
.card-5:hover h2,
.card-5:hover p {
  color: #ffffff !important;
}

.card-5:hover svg path {
  fill: #ffffff !important;
}

.card-6 {
  background-color: #fff;
  margin-top: 20px;
  padding: 30px 30px 20px 30px;
  border-bottom: 5px solid #fcab10;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),
    0px 0px 4px 0px rgba(0, 0, 0, 0.04);
  background-image: linear-gradient(to bottom, transparent 50%, #fcab10 50%);
  background-position: 0 0;
  background-size: 100% 200%;
  transition: background-position 0.25s ease-in;
}
.card-6:hover {
  background-position: 0 100%;
}

.card-6 button {
  background-color: transparent;
  border: 1px solid #828282;
  border-radius: 50px;
  color: #fcab10;
  width: 48%;
  padding: 5px 0px;
}

.card-6:hover button {
  border: 1px solid #ffffff;
  border-radius: 50px;
  color: #ffffff;
  padding: 5px 0px;
}

.card-6:hover .notification-icon .badge {
  background-color: #ffffff !important;
  color: #fcab10;
}

.card-6:hover h6,
.card-6:hover h2,
.card-6:hover p {
  color: #ffffff !important;
}

.card-6:hover svg path {
  fill: #ffffff !important;
}

.card-7 {
  background-color: #fff;
  margin-top: 20px;
  padding: 30px 30px 20px 30px;
  border-bottom: 5px solid #284b63;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),
    0px 0px 4px 0px rgba(0, 0, 0, 0.04);
  background-image: linear-gradient(to bottom, transparent 50%, #284b63 50%);
  background-position: 0 0;
  background-size: 100% 200%;
  transition: background-position 0.25s ease-in;
}
.card-7:hover {
  background-position: 0 100%;
}

.card-7 button {
  background-color: transparent;
  border: 1px solid #828282;
  border-radius: 50px;
  color: #284b63;
  width: 48%;
  padding: 5px 0px;
}

.card-7:hover button {
  border: 1px solid #ffffff;
  border-radius: 50px;
  color: #ffffff;
  padding: 5px 0px;
}

.card-7:hover .notification-icon .badge {
  background-color: #ffffff !important;
  color: #284b63;
}

.card-7:hover h6,
.card-7:hover h2,
.card-7:hover p {
  color: #ffffff !important;
}

.card-7:hover svg path {
  fill: #ffffff !important;
}

.card-8 {
  background-color: #fff;
  margin-top: 20px;
  padding: 30px 30px 20px 30px;
  border-bottom: 5px solid #5b7553;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),
    0px 0px 4px 0px rgba(0, 0, 0, 0.04);
  background-image: linear-gradient(to bottom, transparent 50%, #5b7553 50%);
  background-position: 0 0;
  background-size: 100% 200%;
  transition: background-position 0.25s ease-in;
}
.card-8:hover {
  background-position: 0 100%;
}

.card-8 button {
  background-color: transparent;
  border: 1px solid #828282;
  border-radius: 50px;
  color: #5b7553;
  width: 48%;
  padding: 5px 0px;
}

.card-8:hover button {
  border: 1px solid #ffffff;
  border-radius: 50px;
  color: #ffffff;
  padding: 5px 0px;
}

.card-8:hover .notification-icon .badge {
  background-color: #ffffff !important;
  color: #5b7553;
}

.card-8:hover h6,
.card-8:hover h2,
.card-8:hover p {
  color: #ffffff !important;
  font-weight: normal !important;
}

.card-8:hover svg path {
  fill: #ffffff !important;
}

.percent-number {
  margin: -18px 0px 0px -25px !important;
  padding: 0 !important;
  text-align: end;
}

.badge-circle {
  height: 10px !important;
  width: 10px !important;
  border-radius: 100% !important;
}

@media only screen and (max-width: 600px) and (min-width: 300px) {
}

.table-responsive {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table-default {
  background-color: #fff;
  margin-top: 19px;
  padding: 30px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),
    0px 0px 4px 0px rgba(0, 0, 0, 0.04);
}

.table th {
  background-color: #f8f9fa;
  padding: 12px 15px;
  text-align: left;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
}

.table td {
  padding: 12px 15px;
  border-bottom: 1px solid #dee2e6;
  vertical-align: middle;
}

.table tr:last-child td {
  border-bottom: none;
}

.table tr:hover td {
  background-color: #f8f9fa;
}

.text-success {
  color: #28a745 !important;
}

.text-center {
  text-align: center;
}

.clients-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: white;
}

.clients-table thead th {
  background-color: #fafafa;
  border-bottom: none;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
}

.clients-table tbody tr:hover {
  background-color: #f8f9fa;
}

.revenue-lines-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: white;
}

.revenue-lines-table thead th {
  background-color: transparent;
  border-bottom: none;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
}

.revenue-lines-table tbody tr:hover {
  background-color: #f8f9fa;
}

.company-icon {
  flex-shrink: 0;
}

.pagination-btn:hover:not(.active) {
  background-color: #f8f9fa !important;
  border-color: #007bff !important;
}

.metrics-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  margin: 1.5rem 0;
}

@media (min-width: 768px) {
  .metrics-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .metrics-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

.metric-card {
  background-color: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.metric-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.metric-title {
  font-size: 0.75rem;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
}

.metric-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 4px 0;
}

.metric-change {
  display: flex;
  align-items: center;
  font-size: 0.75rem;
}

.metric-change.positive {
  color: #10b981;
}

.metric-change.negative {
  color: #ef4444;
}

/* Margin Alert Styles */
.marginAlert {
  background-color: rgb(242, 153, 74, 0.2);
  border: none;
  border-radius: 8px;
  padding: 12px 16px 12px 37px;
  margin: 27px 0 37px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: system-ui, -apple-system, sans-serif;
  height: 80px;
}

.marginAlertIcon {
  width: 20px;
  height: 20px;
  background-color: #ae6900;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.marginAlertIconText {
  font-size: 24px;
  font-weight: bold;
  color: #92400e;
}

.marginAlertText {
  color: #92400e;
  font-size: 14px;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/styles/dashboard.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC;uCACqC;AACvC;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC;uCACqC;EACrC,0EAA0E;EAC1E,wBAAwB;EACxB,0BAA0B;EAC1B,6CAA6C;AAC/C;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC;uCACqC;EACrC,0EAA0E;EAC1E,wBAAwB;EACxB,0BAA0B;EAC1B,6CAA6C;AAC/C;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC;uCACqC;EACrC,0EAA0E;EAC1E,wBAAwB;EACxB,0BAA0B;EAC1B,6CAA6C;AAC/C;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC;uCACqC;EACrC,0EAA0E;EAC1E,wBAAwB;EACxB,0BAA0B;EAC1B,6CAA6C;AAC/C;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC;uCACqC;EACrC,0EAA0E;EAC1E,wBAAwB;EACxB,0BAA0B;EAC1B,6CAA6C;AAC/C;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC;uCACqC;EACrC,0EAA0E;EAC1E,wBAAwB;EACxB,0BAA0B;EAC1B,6CAA6C;AAC/C;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC;uCACqC;EACrC,0EAA0E;EAC1E,wBAAwB;EACxB,0BAA0B;EAC1B,6CAA6C;AAC/C;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC;uCACqC;EACrC,0EAA0E;EAC1E,wBAAwB;EACxB,0BAA0B;EAC1B,6CAA6C;AAC/C;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;AACA;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb;uCACqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iDAAiD;EACjD,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".card-default {\n  background-color: #fff;\n  margin-top: 19px;\n  padding: 30px;\n  border-bottom: 5px solid #008cfe;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),\n    0px 0px 4px 0px rgba(0, 0, 0, 0.04);\n}\n.card-1 {\n  background-color: #fff;\n  margin-top: 20px;\n  padding: 30px 30px 20px 30px;\n  border-bottom: 5px solid #008cfe;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),\n    0px 0px 4px 0px rgba(0, 0, 0, 0.04);\n  background-image: linear-gradient(to bottom, transparent 50%, #008cfe 50%);\n  background-position: 0 0;\n  background-size: 100% 200%;\n  transition: background-position 0.25s ease-in;\n}\n.card-1:hover {\n  background-position: 0 100%;\n}\n\n.card-1 button {\n  background-color: transparent;\n  border: 1px solid #828282;\n  border-radius: 50px;\n  color: #008cfe;\n  width: 48%;\n  padding: 5px 0px;\n}\n\n.notification-icon .badge {\n  background-color: #eb5757;\n  border-radius: 46.308px;\n  font-size: 10px;\n  padding: 3px 5px;\n  vertical-align: top;\n  margin-left: -16px;\n}\n\n.card-1:hover button {\n  border: 1px solid #ffffff;\n  border-radius: 50px;\n  color: #ffffff;\n  padding: 5px 0px;\n}\n\n.card-1:hover .notification-icon .badge {\n  background-color: #ffffff !important;\n  color: #008cfe;\n}\n\n.card-1:hover h6,\n.card-1:hover h2,\n.card-1:hover p {\n  color: #ffffff !important;\n}\n\n.card-1:hover svg path {\n  fill: #ffffff !important;\n}\n\n.card-2 {\n  background-color: #fff;\n  margin-top: 20px;\n  padding: 30px 30px 20px 30px;\n  border-bottom: 5px solid #03256c;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),\n    0px 0px 4px 0px rgba(0, 0, 0, 0.04);\n  background-image: linear-gradient(to bottom, transparent 50%, #03256c 50%);\n  background-position: 0 0;\n  background-size: 100% 200%;\n  transition: background-position 0.25s ease-in;\n}\n.card-2:hover {\n  background-position: 0 100%;\n}\n\n.card-2 button {\n  background-color: transparent;\n  border: 1px solid #828282;\n  border-radius: 50px;\n  color: #03256c;\n  width: 48%;\n  padding: 5px 0px;\n}\n\n.card-2:hover button {\n  border: 1px solid #ffffff;\n  border-radius: 50px;\n  color: #ffffff;\n  padding: 5px 0px;\n}\n\n.card-2:hover .notification-icon .badge {\n  background-color: #ffffff !important;\n  color: #03256c;\n}\n\n.card-2:hover h6,\n.card-2:hover h2,\n.card-2:hover p {\n  color: #ffffff !important;\n}\n\n.card-2:hover svg path {\n  fill: #ffffff !important;\n}\n\n.card-3 {\n  background-color: #fff;\n  margin-top: 20px;\n  padding: 30px 30px 20px 30px;\n  border-bottom: 5px solid #854c27;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),\n    0px 0px 4px 0px rgba(0, 0, 0, 0.04);\n  background-image: linear-gradient(to bottom, transparent 50%, #854c27 50%);\n  background-position: 0 0;\n  background-size: 100% 200%;\n  transition: background-position 0.25s ease-in;\n}\n.card-3:hover {\n  background-position: 0 100%;\n}\n\n.card-3 button {\n  background-color: transparent;\n  border: 1px solid #828282;\n  border-radius: 50px;\n  color: #854c27;\n  width: 48%;\n  padding: 5px 0px;\n}\n\n.card-3:hover button {\n  border: 1px solid #ffffff;\n  border-radius: 50px;\n  color: #ffffff;\n  padding: 5px 0px;\n}\n\n.card-3:hover .notification-icon .badge {\n  background-color: #ffffff !important;\n  color: #854c27;\n}\n\n.card-3:hover h6,\n.card-3:hover h2,\n.card-3:hover p {\n  color: #ffffff !important;\n}\n\n.card-3:hover svg path {\n  fill: #ffffff !important;\n}\n\n.card-4 {\n  background-color: #fff;\n  margin-top: 20px;\n  padding: 30px 30px 20px 30px;\n  border-bottom: 5px solid #dd7230;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),\n    0px 0px 4px 0px rgba(0, 0, 0, 0.04);\n  background-image: linear-gradient(to bottom, transparent 50%, #dd7230 50%);\n  background-position: 0 0;\n  background-size: 100% 200%;\n  transition: background-position 0.25s ease-in;\n}\n.card-4:hover {\n  background-position: 0 100%;\n}\n\n.card-4 button {\n  background-color: transparent;\n  border: 1px solid #828282;\n  border-radius: 50px;\n  color: #dd7230;\n  width: 48%;\n  padding: 5px 0px;\n}\n\n.card-4:hover button {\n  border: 1px solid #ffffff;\n  border-radius: 50px;\n  color: #ffffff;\n  padding: 5px 0px;\n}\n\n.card-4:hover .notification-icon .badge {\n  background-color: #ffffff !important;\n  color: #dd7230;\n}\n\n.card-4:hover h6,\n.card-4:hover h2,\n.card-4:hover p {\n  color: #ffffff !important;\n}\n\n.card-4:hover svg path {\n  fill: #ffffff !important;\n}\n\n.card-5 {\n  background-color: #fff;\n  margin-top: 20px;\n  padding: 30px 30px 20px 30px;\n  border-bottom: 5px solid #44af69;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),\n    0px 0px 4px 0px rgba(0, 0, 0, 0.04);\n  background-image: linear-gradient(to bottom, transparent 50%, #44af69 50%);\n  background-position: 0 0;\n  background-size: 100% 200%;\n  transition: background-position 0.25s ease-in;\n}\n.card-5:hover {\n  background-position: 0 100%;\n}\n\n.card-5 button {\n  background-color: transparent;\n  border: 1px solid #828282;\n  border-radius: 50px;\n  color: #44af69;\n  width: 48%;\n  padding: 5px 0px;\n}\n\n.card-5:hover button {\n  border: 1px solid #ffffff;\n  border-radius: 50px;\n  color: #ffffff;\n  padding: 5px 0px;\n}\n\n.card-5:hover .notification-icon .badge {\n  background-color: #ffffff !important;\n  color: #44af69;\n}\n\n.card-5:hover h6,\n.card-5:hover h2,\n.card-5:hover p {\n  color: #ffffff !important;\n}\n\n.card-5:hover svg path {\n  fill: #ffffff !important;\n}\n\n.card-6 {\n  background-color: #fff;\n  margin-top: 20px;\n  padding: 30px 30px 20px 30px;\n  border-bottom: 5px solid #fcab10;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),\n    0px 0px 4px 0px rgba(0, 0, 0, 0.04);\n  background-image: linear-gradient(to bottom, transparent 50%, #fcab10 50%);\n  background-position: 0 0;\n  background-size: 100% 200%;\n  transition: background-position 0.25s ease-in;\n}\n.card-6:hover {\n  background-position: 0 100%;\n}\n\n.card-6 button {\n  background-color: transparent;\n  border: 1px solid #828282;\n  border-radius: 50px;\n  color: #fcab10;\n  width: 48%;\n  padding: 5px 0px;\n}\n\n.card-6:hover button {\n  border: 1px solid #ffffff;\n  border-radius: 50px;\n  color: #ffffff;\n  padding: 5px 0px;\n}\n\n.card-6:hover .notification-icon .badge {\n  background-color: #ffffff !important;\n  color: #fcab10;\n}\n\n.card-6:hover h6,\n.card-6:hover h2,\n.card-6:hover p {\n  color: #ffffff !important;\n}\n\n.card-6:hover svg path {\n  fill: #ffffff !important;\n}\n\n.card-7 {\n  background-color: #fff;\n  margin-top: 20px;\n  padding: 30px 30px 20px 30px;\n  border-bottom: 5px solid #284b63;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),\n    0px 0px 4px 0px rgba(0, 0, 0, 0.04);\n  background-image: linear-gradient(to bottom, transparent 50%, #284b63 50%);\n  background-position: 0 0;\n  background-size: 100% 200%;\n  transition: background-position 0.25s ease-in;\n}\n.card-7:hover {\n  background-position: 0 100%;\n}\n\n.card-7 button {\n  background-color: transparent;\n  border: 1px solid #828282;\n  border-radius: 50px;\n  color: #284b63;\n  width: 48%;\n  padding: 5px 0px;\n}\n\n.card-7:hover button {\n  border: 1px solid #ffffff;\n  border-radius: 50px;\n  color: #ffffff;\n  padding: 5px 0px;\n}\n\n.card-7:hover .notification-icon .badge {\n  background-color: #ffffff !important;\n  color: #284b63;\n}\n\n.card-7:hover h6,\n.card-7:hover h2,\n.card-7:hover p {\n  color: #ffffff !important;\n}\n\n.card-7:hover svg path {\n  fill: #ffffff !important;\n}\n\n.card-8 {\n  background-color: #fff;\n  margin-top: 20px;\n  padding: 30px 30px 20px 30px;\n  border-bottom: 5px solid #5b7553;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),\n    0px 0px 4px 0px rgba(0, 0, 0, 0.04);\n  background-image: linear-gradient(to bottom, transparent 50%, #5b7553 50%);\n  background-position: 0 0;\n  background-size: 100% 200%;\n  transition: background-position 0.25s ease-in;\n}\n.card-8:hover {\n  background-position: 0 100%;\n}\n\n.card-8 button {\n  background-color: transparent;\n  border: 1px solid #828282;\n  border-radius: 50px;\n  color: #5b7553;\n  width: 48%;\n  padding: 5px 0px;\n}\n\n.card-8:hover button {\n  border: 1px solid #ffffff;\n  border-radius: 50px;\n  color: #ffffff;\n  padding: 5px 0px;\n}\n\n.card-8:hover .notification-icon .badge {\n  background-color: #ffffff !important;\n  color: #5b7553;\n}\n\n.card-8:hover h6,\n.card-8:hover h2,\n.card-8:hover p {\n  color: #ffffff !important;\n  font-weight: normal !important;\n}\n\n.card-8:hover svg path {\n  fill: #ffffff !important;\n}\n\n.percent-number {\n  margin: -18px 0px 0px -25px !important;\n  padding: 0 !important;\n  text-align: end;\n}\n\n.badge-circle {\n  height: 10px !important;\n  width: 10px !important;\n  border-radius: 100% !important;\n}\n\n@media only screen and (max-width: 600px) and (min-width: 300px) {\n}\n\n.table-responsive {\n  overflow-x: auto;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table-default {\n  background-color: #fff;\n  margin-top: 19px;\n  padding: 30px;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06),\n    0px 0px 4px 0px rgba(0, 0, 0, 0.04);\n}\n\n.table th {\n  background-color: #f8f9fa;\n  padding: 12px 15px;\n  text-align: left;\n  font-weight: 600;\n  color: #495057;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.table td {\n  padding: 12px 15px;\n  border-bottom: 1px solid #dee2e6;\n  vertical-align: middle;\n}\n\n.table tr:last-child td {\n  border-bottom: none;\n}\n\n.table tr:hover td {\n  background-color: #f8f9fa;\n}\n\n.text-success {\n  color: #28a745 !important;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.clients-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: white;\n}\n\n.clients-table thead th {\n  background-color: #fafafa;\n  border-bottom: none;\n  font-weight: 500;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.clients-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.revenue-lines-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: white;\n}\n\n.revenue-lines-table thead th {\n  background-color: transparent;\n  border-bottom: none;\n  font-weight: 500;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.revenue-lines-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.company-icon {\n  flex-shrink: 0;\n}\n\n.pagination-btn:hover:not(.active) {\n  background-color: #f8f9fa !important;\n  border-color: #007bff !important;\n}\n\n.metrics-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n  margin: 1.5rem 0;\n}\n\n@media (min-width: 768px) {\n  .metrics-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 1024px) {\n  .metrics-grid {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n.metric-card {\n  background-color: white;\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.metric-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.metric-title {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 8px;\n}\n\n.metric-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin: 4px 0;\n}\n\n.metric-change {\n  display: flex;\n  align-items: center;\n  font-size: 0.75rem;\n}\n\n.metric-change.positive {\n  color: #10b981;\n}\n\n.metric-change.negative {\n  color: #ef4444;\n}\n\n/* Margin Alert Styles */\n.marginAlert {\n  background-color: rgb(242, 153, 74, 0.2);\n  border: none;\n  border-radius: 8px;\n  padding: 12px 16px 12px 37px;\n  margin: 27px 0 37px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-family: system-ui, -apple-system, sans-serif;\n  height: 80px;\n}\n\n.marginAlertIcon {\n  width: 20px;\n  height: 20px;\n  background-color: #ae6900;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.marginAlertIconText {\n  font-size: 24px;\n  font-weight: bold;\n  color: #92400e;\n}\n\n.marginAlertText {\n  color: #92400e;\n  font-size: 14px;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
